import Vue from "vue";
import { HelperFunctions } from "@/services/helper-functions";
Vue.filter("round", (value: any) => {
  if (!value) return 0;
  return HelperFunctions.round(value);
});
